import React from "react";
import styled, { keyframes } from "styled-components";
import { SIDEBAR_TEXT } from "../settings/colors";

const DEFAULT_SIZE = 8;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }

  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }

  80% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Ball = styled.div`
  display: inline-block;
  border: 0px solid transparent;
  background: ${props => props.color || SIDEBAR_TEXT};
  width: ${props => props.size || DEFAULT_SIZE}px;
  height: ${props => props.size || DEFAULT_SIZE}px;
  margin: ${props => props.margin || 2}px;
  border-radius: 100%;
  animation: 0.75s cubic-bezier(0.2, 0.68, 0.18, 1.08)
    ${props => props.iteration * 0.12 + "s"} infinite both ${pulse};
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const PulseLoader = ({ color, size, margin, ...otherProps }) => {
  const ballProps = { color, size, margin };

  return (
    <Wrapper {...otherProps}>
      <Ball iteration={1} {...ballProps} />
      <Ball iteration={2} {...ballProps} />
      <Ball iteration={3} {...ballProps} />
    </Wrapper>
  );
};

export default PulseLoader;



// WEBPACK FOOTER //
// ./src/components/PulseLoader.js